module.exports = __webpack_public_path__ + "img/conf_ferie_permessi_maturati.b0c7154a.png";